import React from 'react';
import { reduxForm, Field, FormSection } from 'redux-form';
import FormField from '../../../forms/FormField';
import { Button, Row, Col } from 'react-bootstrap';

const FolderForm = props => {
  const { handleSubmit, pristine, reset, submitting, asset } = props;
  const { opts } = asset || {};
  const { label, fields } = opts || {};
  return (
    <form onSubmit={handleSubmit}>
      <Field
        name={'folder'}
        type="text"
        component={FormField.Input}
        label={'Folder'}
        validate={[
          v => !v ? 'Required' : undefined,
          v => {
            if (!v) return undefined;
            if (v[0] === '/') return `Folder can not begin with '/'`;
            if (v[v.length - 1] === '/') return `Folder can not end with '/'`;
            return undefined;
          }
        ]}
      />
      <div className="text-right">
        <Button type="button" bsStyle="hollow-info" disabled={pristine || submitting} onClick={reset}>
          <span className="ti ti-close" /> Clear Values
        </Button>
        {' '}
        <Button bsStyle="success" type="button" disabled={submitting} onClick={handleSubmit}>
          <span className="ti ti-check" /> Submit
        </Button>
      </div>
    </form>
  );
};

export default reduxForm({
  form: 'folder-form', // a unique identifier for this form
  validate: () => ({}),                // <--- validation function given to redux-form
  // warn                     // <--- warning function given to redux-form
})(FolderForm);



// WEBPACK FOOTER //
// ./src/components/routes/files/forms/AddFolderForm.js